import React, { useEffect } from "react";
import Swiper from "swiper/bundle";
import "swiper/css/bundle";
import { Link } from "react-router-dom";

const HomePage = () => {
  useEffect(() => {
    const swiper = new Swiper(".h7-testimonial-slider", {
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 15,
      loop: true,
      autoplay: {
        delay: 4500,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".h5-story-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".h5-story-next",
        prevEl: ".h5-story-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 1,
          spaceBetween: 50,
        },
      },
    });

    return () => swiper.destroy(true, true); // cleanup
  }, []);

  useEffect(() => {
    const swiper = new Swiper(".h3-partner_slider", {
      slidesPerView: 2,
      spaceBetween: 15,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: { slidesPerView: 3, spaceBetween: 30 },
        992: { slidesPerView: 5, spaceBetween: 30 },
      },
    });

    return () => swiper.destroy(true, true);
  }, []);

  return (
    <>

      {/*===== HERO AREA STARTS =======*/}
      <div className="relative bg-gradient-to-r from-[#000000] to-[#190538] pb-32 mt-[86px] overflow-hidden max-md:mt-[78px]">
        <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-[0]">
          <svg
            className="relative w-full h-[100px]"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1200 100"
            preserveAspectRatio="none"
          >
            <path
              d="M0,0 C300,100 900,100 1200,0 L1200,100 L0,100 Z"
              fill="#ffffff"
            />
          </svg>
        </div>
        <div className="w-full text-white py-12 px-6 sm:px-12 md:px-20 lg:px-32 flex flex-col-reverse md:flex-row items-center justify-between gap-10 relative">
          <div className="max-w-xl">
            <p className="text-md text-[#c3a8ed] uppercase font-medium tracking-wide max-md:text-center">
              Your Complete Health and Wellness Package
            </p>
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold leading-tight mt-2 max-md:text-center">
              All for your family <br />
              <span className="text-[#5b21b6] animate-fadeInUp delay-200">
                Protective Health
              </span>
            </h1>
            <p className="text-base sm:text-lg text-white mt-4 max-md:text-center">
              Access comprehensive health coverage with expert guidance, discounts,
              and additional wellness benefits at an affordable price.
            </p>
            <div className="mt-5 max-md:w-full max-md:flex max-md:justify-center">
              <a href="/about-us" target="_blank">
                <button class="frutiger-button">
                  <div class="inner">
                    <div class="top-white"></div>
                    <span class="text">Read More</span>
                  </div>
                </button>
              </a>
            </div>
          </div>
          <div className="w-full max-w-sm sm:max-w-md md:max-w-lg mx-auto text-center relative">
            <div className="relative mt-10 flex items-center justify-center">
              <div className="absolute top-2 left-2  bg-[#5b21b680] text-white text-xs sm:text-sm px-3 py-1 rounded-full shadow-md border border-slate-200">
                Mental Wellness Support
              </div>
              <div className="absolute bottom-2 right-2 bg-[#5b21b680] text-white text-xs sm:text-sm px-3 py-1 rounded-full shadow-md border border-slate-200">
                Big Discounts on Health Essentials
              </div>
              <div className="p-2  rounded-full inline-block">
                <img
                  src="assets/img/all-images/image-1.png"
                  alt="Meditating Woman"
                  className="rounded-full object-cover w-[300px] sm:w-[400px] md:w-[500px] h-[300px] sm:h-[400px] md:h-[500px] border-4 border-[#5b21b6] shadow-xl transition-opacity duration-700 mx-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*===== HERO AREA ENDS =======*/}




      {/* PROCESS AREA STARTS */}
      <section className="bg-white px-4 py-12 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-10 relative">
          <div className="w-full md:w-1/2 relative  text-center md:text-left">
            <div
              className="absolute -top-12 left-1/2 md:left-0 transform -translate-x-1/2 md:translate-x-0 text-[40px] sm:text-[60px] md:text-[72px] font-extrabold italic  leading-tight  text-transparent bg-gradient-to-r from-slate-600 to-[#5b21b6] bg-clip-text opacity-20
"
            >
              <div>Care Beyond</div>
              <div>Coverage</div>
            </div>
            <div className="relative  mt-8 text-center ">
              <h2 className="text-[#5b21b6] text-2xl sm:text-3xl font-bold leading-tight">
                <span className="d-block">
                  {" "}
                  Coverage That Covers <br /> You.
                </span>
              </h2>
              <h3 className="mt-4 text-black text-2xl sm:text-3xl font-bold italic leading-snug mb-8">
                real stories.
                <br />
                real protection.
              </h3>
              <p className="text-start">
                We believe that healthcare should be accessible, comprehensive, and
                personalized. Our mission is to transform the healthcare experience by
                offering tailored insurance plans that prioritize your well-being.
              </p>
              <ul className="list-none space-y-3 text-base sm:text-lg text-[#333] mt-6 text-left">
                <li className="before:content-['»'] before:mr-2 font-medium ">
                  Discounts on Diagnostic Tests &amp; Medicines
                </li>
                <li className="before:content-['»'] before:mr-2 font-medium ">
                  Free Comprehensive Health Check-Up
                </li>
                <li className="before:content-['»'] before:mr-2 font-medium ">
                  Eye &amp; Dental Benefits
                </li>
                <li className="before:content-['»'] before:mr-2 font-medium ">
                  Mental Wellness Benefits
                </li>
              </ul>
            </div>
          </div>
          <div className="w-full md:w-1/2">
            <img
              src="assets/img/all-images/coverage.jpg"
              alt="Family protection"
              className="w-full rounded-lg shadow-lg object-cover"
            />
          </div>
        </div>
      </section>

      {/* PROCESS AREA ENDS */}

      {/*===== SERVICE AREA STARTS =======*/}
      <div className="p-4 sm:p-8 lg:p-12 bg-white font-sans m-4 max-md:!p-[0px] max-md:!mb-[80px]">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="group p-6 border-2 border-dashed border-gray-300 rounded-lg flex flex-col items-start text-left h-full transition-shadow duration-300 hover:shadow-xl">
            <div className="text-slate-500 group-hover:text-[#5b21b6] mb-4 transition-colors duration-300 group-hover:animate-fadeInUp delay-200">
              <svg
                stroke="#5b21b6"
                fill="#5b21b6"
                strokeWidth={0}
                viewBox="0 0 512 512"
                height={40}
                width={40}
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"></path>
              </svg>
            </div>
            <h3
              className="text-lg font-semibold text-[#5b21b6] mb-2 leading-tight"
              style={{ fontFamily: "Montserrat, sans-serif" }}
            >
              Clear and Honest Plans
            </h3>
            <p className="text-gray-700 text-sm leading-relaxed">
              No hidden clauses, no jargon – just straight answers.
            </p>
          </div>
          <div className="group p-6 border-2 border-dashed border-gray-300 rounded-lg flex flex-col items-start text-left h-full transition-shadow duration-300 hover:shadow-xl">
            <div className="text-slate-500 group-hover:text-[#5b21b6] mb-4 transition-colors duration-300 group-hover:animate-fadeInUp delay-200">
              <svg
                stroke="#5b21b6"
                fill="#5b21b6"
                strokeWidth={0}
                viewBox="0 0 640 512"
                height={40}
                width={40}
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M622.3 271.1l-115.2-45c-4.1-1.6-12.6-3.7-22.2 0l-115.2 45c-10.7 4.2-17.7 14-17.7 24.9 0 111.6 68.7 188.8 132.9 213.9 9.6 3.7 18 1.6 22.2 0C558.4 489.9 640 420.5 640 296c0-10.9-7-20.7-17.7-24.9zM496 462.4V273.3l95.5 37.3c-5.6 87.1-60.9 135.4-95.5 151.8zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm96 40c0-2.5.8-4.8 1.1-7.2-2.5-.1-4.9-.8-7.5-.8h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c6.8 0 13.3-1.5 19.2-4-54-42.9-99.2-116.7-99.2-212z"></path>
              </svg>
            </div>
            <h3
              className="text-lg font-semibold text-[#5b21b6] mb-2 leading-tight"
              style={{ fontFamily: "Montserrat, sans-serif" }}
            >
              Fast and Friendly Support
            </h3>
            <p className="text-gray-700 text-sm leading-relaxed">
              Real people, real help, whenever you need it.
            </p>
          </div>
          <div className="group p-6 border-2 border-dashed border-gray-300 rounded-lg flex flex-col items-start text-left h-full transition-shadow duration-300 hover:shadow-xl">
            <div className="text-slate-500 group-hover:text-[#5b21b6] mb-4 transition-colors duration-300 group-hover:animate-fadeInUp delay-200">
              <svg
                stroke="#5b21b6"
                fill="#5b21b6"
                strokeWidth={0}
                viewBox="0 0 512 512"
                height={40}
                width={40}
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM256.1 446.3l-.1-381 175.9 73.3c-3.3 151.4-82.1 261.1-175.8 307.7z"></path>
              </svg>
            </div>
            <h3
              className="text-lg font-semibold text-[#5b21b6] mb-2 leading-tight"
              style={{ fontFamily: "Montserrat, sans-serif" }}
            >
              Fresh and Innovative
            </h3>
            <p className="text-gray-700 text-sm leading-relaxed">
              A new approach to health and wellness, designed with you in mind
            </p>
          </div>
          <div className="group p-6 border-2 border-dashed border-gray-300 rounded-lg flex flex-col items-start text-left h-full transition-shadow duration-300 hover:shadow-xl">
            <div className="text-slate-500 group-hover:text-[#5b21b6] mb-4 transition-colors duration-300 group-hover:animate-fadeInUp delay-200">
              <svg
                stroke="#5b21b6"
                fill="#5b21b6"
                strokeWidth={0}
                viewBox="0 0 512 512"
                height={40}
                width={40}
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M256 112a56 56 0 1 0-56-56 56 56 0 0 0 56 56zm176 336H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm72.87-263.84l-28.51-15.92c-7.44-5-16.91-2.46-22.29 4.68a47.59 47.59 0 0 1-47.23 18.23C383.7 186.86 368 164.93 368 141.4a13.4 13.4 0 0 0-13.4-13.4h-38.77c-6 0-11.61 4-12.86 9.91a48 48 0 0 1-93.94 0c-1.25-5.92-6.82-9.91-12.86-9.91H157.4a13.4 13.4 0 0 0-13.4 13.4c0 25.69-19 48.75-44.67 50.49a47.5 47.5 0 0 1-41.54-19.15c-5.28-7.09-14.73-9.45-22.09-4.54l-28.57 16a16 16 0 0 0-5.44 20.47L104.24 416h303.52l102.55-211.37a16 16 0 0 0-5.44-20.47z"></path>
              </svg>
            </div>
            <h3
              className="text-lg font-semibold text-[#5b21b6] mb-2 leading-tight"
              style={{ fontFamily: "Montserrat, sans-serif" }}
            >
              Tailored for You
            </h3>
            <p className="text-gray-700 text-sm leading-relaxed">
              Flexible plans that fit your life, not the other way around.
            </p>
          </div>
        </div>
      </div>
      <div className="relative bg-gradient-to-r from-[#000000] to-[#190538] text-white  overflow-hidden">
        <div className="relative w-full px-6 py-16 lg:py-24">
          <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center lg:items-start">
            <div className="lg:w-1/2 text-left lg:text-left">
              <h1 className="text-4xl lg:text-5xl font-bold leading-tight">
                Our Plans, Your <br /> Peace of Mind
              </h1>
              <h2 className="text-accent text-2xl lg:text-3xl text-[#5b21b6] font-bold italic mt-4">
                choose what fits you best
              </h2>
              <p className="mt-6 text-base lg:text-lg opacity-90">
                With an array of services that range from diagnostic discounts to
                emergency room coverage, we are committed to providing you with the
                peace of mind you deserve.
              </p>
              <div className="mt-3">
                <a href="/about-us" target="_blank">
                  <button class="frutiger-button">
                    <div class="inner">
                      <div class="top-white"></div>
                      <span class="text">Start Exploring</span>
                      <span className="inline-block ml-2 translate-y-[6px]">
                        <svg
                          stroke="#ffffff"
                          fill="#ffffff"
                          strokeWidth={0}
                          viewBox="0 0 512 512"
                          height={20}
                          width={20}
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M0 405.3V448c0 35.3 86 64 192 64s192-28.7 192-64v-42.7C342.7 434.4 267.2 448 192 448S41.3 434.4 0 405.3zM320 128c106 0 192-28.7 192-64S426 0 320 0 128 28.7 128 64s86 64 192 64zM0 300.4V352c0 35.3 86 64 192 64s192-28.7 192-64v-51.6c-41.3 34-116.9 51.6-192 51.6S41.3 334.4 0 300.4zm416 11c57.3-11.1 96-31.7 96-55.4v-42.7c-23.2 16.4-57.3 27.6-96 34.5v63.6zM192 160C86 160 0 195.8 0 240s86 80 192 80 192-35.8 192-80-86-80-192-80zm219.3 56.3c60-10.8 100.7-32 100.7-56.3v-42.7c-35.5 25.1-96.5 38.6-160.7 41.8 29.5 14.3 51.2 33.5 60 57.2z"></path>
                        </svg>
                      </span>
                    </div>
                  </button>
                </a>
              </div>
            </div>
            <div className="lg:w-1/2 mt-12 lg:mt-0 flex justify-center">
              <img
                src="assets/img/all-images/illustrated-money.png"
                alt="Plan Illustration"
                className="w-full max-w-md object-contain"
              />
            </div>
          </div>
        </div>
        {/* <div className="-mt-12 lg:-mt-20">
          <section className="bg-white py-12 px-4 sm:px-6 lg:px-8 font-sans">
            <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 items-start">
              <div
                className="bg-white rounded-xl shadow-lg overflow-hidden border-t-8 border-t-slate-500 p-8 flex flex-col items-center text-center h-full"
                style={{ boxShadow: "rgba(148, 163, 184, 0.4) 0px 8px 30px" }}
              >
                <h3 className="text-2xl font-bold text-[#5b21b6] mb-4">
                  Preventive Pulse Premium care
                </h3>
                <p className="text-4xl font-extrabold text-gray-900 mb-6">
                  ₹ 29,999
                  <span className="text-base font-normal text-gray-600 ml-2">
                    (+ GST)
                  </span>
                </p>
                <ul className="text-slate-700 text-left space-y-4 mb-8">
                  <li className="flex items-start">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#5b21b6"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                      aria-hidden="true"
                    >
                      <path d="M20 6 9 17l-5-5" />
                    </svg>
                    <span>
                      <strong className="text-gray-800">
                        Unlimited
                      </strong>{" "}
                      – Tele Doctor Consultation (GP)
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#5b21b6"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                      aria-hidden="true"
                    >
                      <path d="M20 6 9 17l-5-5" />
                    </svg>
                    <span>
                      <strong className="text-gray-800">
                        Unlimited
                      </strong>{" "}
                      – Tele Doctor Consultation (Ayurveda)
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#5b21b6"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                      aria-hidden="true"
                    >
                      <path d="M20 6 9 17l-5-5" />
                    </svg>
                    <span>
                      <strong className="text-gray-800">
                        Unlimited
                      </strong>{" "}
                      – Tele Doctor Consultation (Homeopathy)
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#5b21b6"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                      aria-hidden="true"
                    >
                      <path d="M20 6 9 17l-5-5" />
                    </svg>
                    <span>
                      <strong className="text-gray-800">
                        Unlimited
                      </strong>{" "}
                      – Tele Doctor Consultation (18 Specialists)
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#5b21b6"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                      aria-hidden="true"
                    >
                      <path d="M20 6 9 17l-5-5" />
                    </svg>
                    <span>
                      <strong className="text-gray-800">
                        2 Credits
                      </strong>{" "}
                      – Full Body Checkup (91 parameters)
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#5b21b6"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                      aria-hidden="true"
                    >
                      <path d="M20 6 9 17l-5-5" />
                    </svg>
                    <span>
                      <strong className="text-gray-800">
                        ₹7500 wallet
                      </strong>{" "}
                      – Diagnostic & Radiology Wallet
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#5b21b6"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                      aria-hidden="true"
                    >
                      <path d="M20 6 9 17l-5-5" />
                    </svg>
                    <span>
                      <strong className="text-gray-800">
                        2 Credit
                      </strong>{" "}
                      – In-person General Physician Clinic & Hospital Consultation / My Choice Doctor
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#5b21b6"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                      aria-hidden="true"
                    >
                      <path d="M20 6 9 17l-5-5" />
                    </svg>
                    <span>
                      <strong className="text-gray-800">
                        ₹2500 wallet
                      </strong>{" "}
                      – Pharmacy Wallet - Prescribed Medicines
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#5b21b6"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                      aria-hidden="true"
                    >
                      <path d="M20 6 9 17l-5-5" />
                    </svg>
                    <span>
                      <strong className="text-gray-800">
                        1 Credit
                      </strong>{" "}
                      – At Home Dental Scan
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#5b21b6"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                      aria-hidden="true"
                    >
                      <path d="M20 6 9 17l-5-5" />
                    </svg>
                    <span>
                      <strong className="text-gray-800">
                        2 Credit
                      </strong>{" "}
                      – Mental Wellness
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#5b21b6"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                      aria-hidden="true"
                    >
                      <path d="M20 6 9 17l-5-5" />
                    </svg>
                    <span>
                      <strong className="text-gray-800">
                        4 Credit
                      </strong>{" "}
                      – Tele Dietician Consultation
                    </span>
                  </li>


                </ul>
                <Link to="/preventivepulsepremiumcare" className="mt-auto bg-[#5b21b6] hover:bg-[#5b21b6] text-white w-full rounded font-bold py-3 px-8 transition-colors duration-200 shadow-md underline">
                  View More Details
                </Link>
              </div>
              <div
                className="relative bg-white rounded-xl shadow-lg overflow-hidden border-t-8 border-t-[#5b21b6] p-8 flex flex-col items-center text-center h-full"
                style={{ boxShadow: "rgba(148, 163, 184, 0.4) 0px 8px 30px" }}
              >
                <div className="absolute top-0 right-0 bg-[#5b21b6] text-white text-xs font-bold uppercase py-1 px-4 transform rotate-45 translate-x-1/3 -translate-y-1/2 origin-top-right">
                  Popular
                </div>
                <h3 className="text-2xl font-bold text-[#5b21b6] mb-4">
                  Preventive Pulse Health Shield
                </h3>
                <p className="text-4xl font-extrabold text-gray-900 mb-6">
                  ₹ 49,999
                  <span className="text-base font-normal text-gray-600 ml-2">
                    (+ GST)
                  </span>
                </p>
                <ul className="text-slate-700 text-left space-y-4 mb-8">
                  <li className="flex items-start">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#5b21b6"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                      aria-hidden="true"
                    >
                      <path d="M20 6 9 17l-5-5" />
                    </svg>
                    <span>
                      <strong className="text-gray-800">
                        Unlimited
                      </strong>{" "}
                      – Tele Doctor Consultation (GP)
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#5b21b6"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                      aria-hidden="true"
                    >
                      <path d="M20 6 9 17l-5-5" />
                    </svg>
                    <span>
                      <strong className="text-gray-800">
                        Unlimited
                      </strong>{" "}
                      – Tele Doctor Consultation (Ayurveda)
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#5b21b6"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                      aria-hidden="true"
                    >
                      <path d="M20 6 9 17l-5-5" />
                    </svg>
                    <span>
                      <strong className="text-gray-800">
                        Unlimited
                      </strong>{" "}
                      – Tele Doctor Consultation (Homeopathy)
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#5b21b6"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                      aria-hidden="true"
                    >
                      <path d="M20 6 9 17l-5-5" />
                    </svg>
                    <span>
                      <strong className="text-gray-800">
                        Unlimited
                      </strong>{" "}
                      – Tele Doctor Consultation (18 Specialists)
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#5b21b6"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                      aria-hidden="true"
                    >
                      <path d="M20 6 9 17l-5-5" />
                    </svg>
                    <span>
                      <strong className="text-gray-800">
                        4 Credits
                      </strong>{" "}
                      – Full Body Checkup (91 parameters)
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#5b21b6"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                      aria-hidden="true"
                    >
                      <path d="M20 6 9 17l-5-5" />
                    </svg>
                    <span>
                      <strong className="text-gray-800">
                        ₹12,500 wallet
                      </strong>{" "}
                      – Diagnostic & Radiology Wallet
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#5b21b6"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                      aria-hidden="true"
                    >
                      <path d="M20 6 9 17l-5-5" />
                    </svg>
                    <span>
                      <strong className="text-gray-800">
                        2 Credit
                      </strong>{" "}
                      – In-person General Physician Clinic & Hospital Consultation / My Choice Doctor
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#5b21b6"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                      aria-hidden="true"
                    >
                      <path d="M20 6 9 17l-5-5" />
                    </svg>
                    <span>
                      <strong className="text-gray-800">
                        ₹3500 wallet
                      </strong>{" "}
                      – Pharmacy Wallet - Prescribed Medicines
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#5b21b6"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                      aria-hidden="true"
                    >
                      <path d="M20 6 9 17l-5-5" />
                    </svg>
                    <span>
                      <strong className="text-gray-800">
                        1 Credit
                      </strong>{" "}
                      – At Home Dental Scan
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#5b21b6"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                      aria-hidden="true"
                    >
                      <path d="M20 6 9 17l-5-5" />
                    </svg>
                    <span>
                      <strong className="text-gray-800">
                        2 Credit
                      </strong>{" "}
                      – Mental Wellness
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#5b21b6"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                      aria-hidden="true"
                    >
                      <path d="M20 6 9 17l-5-5" />
                    </svg>
                    <span>
                      <strong className="text-gray-800">
                        4 Credit
                      </strong>{" "}
                      – Tele Dietician Consultation
                    </span>
                  </li>
                </ul>
                <Link to="/preventivepulsehealthshield" className="mt-auto bg-[#5b21b6] hover:bg-[#5b21b6] w-full text-white font-bold py-3 px-8 rounded underline transition-colors duration-200 shadow-md">
                  View More Details
                </Link>
              </div>
            </div>
          </section>
        </div> */}
      </div>
      <section className="bg-gradient-to-r from-[#ffffff] to-[#f7f8fc] py-16 px-4 sm:px-6 lg:px-8 font-sans">
        <div className="max-w-7xl mx-auto text-center">
          <p className="text-lg font-bold text-[#5b21b6]  tracking-wider">
            Preventive Pulse
          </p>
          <h2 className="text-4xl md:text-5xl font-extrabold text-[#13202C] leading-tight mt-2 mb-6">
            What Our Clients Say
          </h2>
          <p className="max-w-3xl mx-auto text-gray-700 text-lg mb-12">
            Read how Preventive Pulse is transforming healthcare experiences for
            individuals and families. Our clients share their stories of enhanced
            well-being and peace of mind through our personalized plans and
            comprehensive benefits.
          </p>
          <div className="relative">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 justify-center items-stretch">
              <div className="relative bg-white p-6 rounded-lg shadow-md flex flex-col items-center h-full">
                <svg
                  stroke="#5b21b6"
                  fill="#5b21b6"
                  strokeWidth={0}
                  version="1.1"
                  viewBox="0 0 16 16"
                  className="absolute -top-4 -left-4 w-12 h-12 text-[#58BFCA] opacity-70"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M3.516 7c1.933 0 3.5 1.567 3.5 3.5s-1.567 3.5-3.5 3.5-3.5-1.567-3.5-3.5l-0.016-0.5c0-3.866 3.134-7 7-7v2c-1.336 0-2.591 0.52-3.536 1.464-0.182 0.182-0.348 0.375-0.497 0.578 0.179-0.028 0.362-0.043 0.548-0.043zM12.516 7c1.933 0 3.5 1.567 3.5 3.5s-1.567 3.5-3.5 3.5-3.5-1.567-3.5-3.5l-0.016-0.5c0-3.866 3.134-7 7-7v2c-1.336 0-2.591 0.52-3.536 1.464-0.182 0.182-0.348 0.375-0.497 0.578 0.179-0.028 0.362-0.043 0.549-0.043z"></path>
                </svg>
                <div className="flex justify-center mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="#5b21b6"
                    aria-hidden="true"
                    data-slot="icon"
                    className="h-5 w-5 text-yellow-400"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401Z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="#5b21b6"
                    aria-hidden="true"
                    data-slot="icon"
                    className="h-5 w-5 text-yellow-400"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401Z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="#5b21b6"
                    aria-hidden="true"
                    data-slot="icon"
                    className="h-5 w-5 text-yellow-400"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401Z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="#5b21b6"
                    aria-hidden="true"
                    data-slot="icon"
                    className="h-5 w-5 text-yellow-400"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401Z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="#5b21b6"
                    aria-hidden="true"
                    data-slot="icon"
                    className="h-5 w-5 text-gray-300"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401Z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <p className="text-gray-600 text-base mb-6 flex-grow">
                  <i>
                    When my mother had a sudden blood pressure spike, I used Preventive Pulse
                    WhatsApp support to get advice. They not only arranged a quick
                    consultation but also recommended a nearby diagnostic lab with a
                    discount. It felt like having a doctor in the family.
                  </i>
                </p>
                <div className="flex items-center mt-auto">
                  <p className="font-semibold text-gray-800 text-lg">Alka Tiwari</p>
                </div>
              </div>
              <div className="relative bg-white p-6 rounded-lg shadow-md flex flex-col items-center h-full">
                <svg
                  stroke="#5b21b6"
                  fill="#5b21b6"
                  strokeWidth={0}
                  version="1.1"
                  viewBox="0 0 16 16"
                  className="absolute -top-4 -left-4 w-12 h-12 text-[#58BFCA] opacity-70"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M3.516 7c1.933 0 3.5 1.567 3.5 3.5s-1.567 3.5-3.5 3.5-3.5-1.567-3.5-3.5l-0.016-0.5c0-3.866 3.134-7 7-7v2c-1.336 0-2.591 0.52-3.536 1.464-0.182 0.182-0.348 0.375-0.497 0.578 0.179-0.028 0.362-0.043 0.548-0.043zM12.516 7c1.933 0 3.5 1.567 3.5 3.5s-1.567 3.5-3.5 3.5-3.5-1.567-3.5-3.5l-0.016-0.5c0-3.866 3.134-7 7-7v2c-1.336 0-2.591 0.52-3.536 1.464-0.182 0.182-0.348 0.375-0.497 0.578 0.179-0.028 0.362-0.043 0.549-0.043z"></path>
                </svg>
                <div className="flex justify-center mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="#5b21b6"
                    aria-hidden="true"
                    data-slot="icon"
                    className="h-5 w-5 text-yellow-400"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401Z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="#5b21b6"
                    aria-hidden="true"
                    data-slot="icon"
                    className="h-5 w-5 text-yellow-400"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401Z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="#5b21b6"
                    aria-hidden="true"
                    data-slot="icon"
                    className="h-5 w-5 text-yellow-400"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401Z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="#5b21b6"
                    aria-hidden="true"
                    data-slot="icon"
                    className="h-5 w-5 text-yellow-400"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401Z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="#5b21b6"
                    aria-hidden="true"
                    data-slot="icon"
                    className="h-5 w-5 text-yellow-400"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401Z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <p className="text-gray-600 text-base mb-6 flex-grow">
                  <i>
                    I've used health plans before, but they all felt transactional.
                    Preventive Pulse is different. They follow up. They check in. My health
                    manager even reminded me when I missed my second check-up. It's
                    that kind of accountability that makes me trust them deeply.
                  </i>
                </p>
                <div className="flex items-center mt-auto">
                  <p className="font-semibold text-gray-800 text-lg">
                    Vinod Agarwal
                  </p>
                </div>
              </div>
              <div className="relative bg-white p-6 rounded-lg shadow-md flex flex-col items-center h-full">
                <svg
                  stroke="#5b21b6"
                  fill="#5b21b6"
                  strokeWidth={0}
                  version="1.1"
                  viewBox="0 0 16 16"
                  className="absolute -top-4 -left-4 w-12 h-12 text-[#58BFCA] opacity-70"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M3.516 7c1.933 0 3.5 1.567 3.5 3.5s-1.567 3.5-3.5 3.5-3.5-1.567-3.5-3.5l-0.016-0.5c0-3.866 3.134-7 7-7v2c-1.336 0-2.591 0.52-3.536 1.464-0.182 0.182-0.348 0.375-0.497 0.578 0.179-0.028 0.362-0.043 0.548-0.043zM12.516 7c1.933 0 3.5 1.567 3.5 3.5s-1.567 3.5-3.5 3.5-3.5-1.567-3.5-3.5l-0.016-0.5c0-3.866 3.134-7 7-7v2c-1.336 0-2.591 0.52-3.536 1.464-0.182 0.182-0.348 0.375-0.497 0.578 0.179-0.028 0.362-0.043 0.549-0.043z"></path>
                </svg>
                <div className="flex justify-center mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="#5b21b6"
                    aria-hidden="true"
                    data-slot="icon"
                    className="h-5 w-5 text-yellow-400"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401Z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="#5b21b6"
                    aria-hidden="true"
                    data-slot="icon"
                    className="h-5 w-5 text-yellow-400"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401Z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="#5b21b6"
                    aria-hidden="true"
                    data-slot="icon"
                    className="h-5 w-5 text-yellow-400"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401Z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="#5b21b6"
                    aria-hidden="true"
                    data-slot="icon"
                    className="h-5 w-5 text-yellow-400"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401Z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="#5b21b6"
                    aria-hidden="true"
                    data-slot="icon"
                    className="h-5 w-5 text-yellow-400"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401Z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <p className="text-gray-600 text-base mb-6 flex-grow">
                  <i>
                    With Preventive Pulse, I don't have to chase multiple providers. Everything
                    I need is in one place. It felt like having a doctor in the
                    family. I was amazed at how smooth it was. I genuinely feel like
                    I have a team looking out for me.
                  </i>
                </p>
                <div className="flex items-center mt-auto">
                  <p className="font-semibold text-gray-800 text-lg">Arvind K</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*===== SERVICE AREA ENDS =======*/}

      {/*===== FREQUENTLY ASKED AREA ENDS =======*/}
      <section className="bg-white py-12 md:py-20 lg:py-24 px-4 sm:px-6 lg:px-8 font-sans">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          <div className="relative flex flex-col items-center justify-center min-h-[300px] lg:min-h-[500px] xl:min-h-[600px] p-4">
            <h2 className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-extrabold text-gray-200 opacity-70 whitespace-nowrap z-0 select-none">
              Frequently <br /> Ask Question
            </h2>
            <img
              src="assets/img/all-images/faq-DGIcXqFE.avif"
              alt="FAQ illustration"
              className="relative max-w-full h-auto object-contain"
            />
            <div className="relative w-full h-full flex items-center justify-center" />
          </div>
          <div className="flex flex-col">
            <div className="mb-8">
              <h3 className="text-sm font-bold text-[#5b21b6] uppercase tracking-wider">
                FAQ's
              </h3>
              <h2 className="text-3xl md:text-4xl font-extrabold text-[#13202C] italic leading-tight mt-2">
                How we can support your healthcare journey
              </h2>
            </div>
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    What is the coverage included in Preventive Pulse plans?
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  className="accordion-collapse collapse show"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Each plan offers a range of benefits such as discounts on diagnostic tests, free health check-ups, eye and dental benefits, mental wellness support, and emergency room coverage. The extent of the coverage depends on the selected plan.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    How do I choose the best plan for me?
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  className="accordion-collapse collapse"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Choosing the best plan depends on your individual healthcare needs, budget, and desired coverage. We recommend reviewing the detailed plan descriptions on our website or contacting our support team for personalized assistance.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    Are mental wellness services covered?
                  </button>
                </h2>
                <div
                  id="collapseThree"
                  className="accordion-collapse collapse"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Yes, many of our Preventive Pulse plans include coverage for mental wellness services, including therapy sessions, counseling, and psychiatric consultations. Please check your specific plan details for more information.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                  >
                    Do the plans include discounts on medicines?
                  </button>
                </h2>
                <div
                  id="collapseFour"
                  className="accordion-collapse collapse"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Absolutely! Several Preventive Pulse plans offer discounts on prescribed medicines at our network pharmacies. This is designed to help make your healthcare more affordable.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFive"
                    aria-expanded="false"
                    aria-controls="collapseFive"
                  >
                    What is the process to enroll in a plan?
                  </button>
                </h2>
                <div
                  id="collapseFive"
                  className="accordion-collapse collapse"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Enrolling in an Preventive Pulse plan is simple. You can visit our website, select your desired plan, fill out the online application form, and complete the payment process. Our team will then reach out to confirm your enrollment.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseSix"
                    aria-expanded="false"
                    aria-controls="collapseSix"
                  >
                    Are there any age restrictions for the plans?
                  </button>
                </h2>
                <div
                  id="collapseSix"
                  className="accordion-collapse collapse"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Preventive Pulse plans are designed to cater to a wide range of age groups. While some plans may have specific age-related features, most are available to individuals and families of all ages. Please refer to individual plan details for any restrictions.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseSeven"
                    aria-expanded="false"
                    aria-controls="collapseSeven"
                  >
                    Can I switch between plans after enrolling?
                  </button>
                </h2>
                <div
                  id="collapseSeven"
                  className="accordion-collapse collapse"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Yes, in most cases, you can switch between Preventive Pulse plans. There might be specific terms and conditions, such as a waiting period or a small administrative fee, associated with plan changes. Contact our customer service for guidance on switching plans.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*===== FREQUENTLY ASKED ENDS =======*/}


    </>
  );
};

export default HomePage;
